import React, { Component } from 'react';

// Material UI Imports
import GridList from '@material-ui/core/GridList';
import GridTile from '@material-ui/core/GridListTile'

// Components Imports
import NormalField from './NormalField';

const styles = {
    gridList: {
        width: "100%",
    },
};

class SmokeTest extends Component {
    render() {
        return (
            <div className="SmokeTest">
                <GridList cols={5} cellHeight="auto" style={styles.gridList} >
                    <GridTile>
                        <NormalField
                            label="Enclosure"
                            input={this.props.smokeTest.enclosure.name} />
                    </GridTile>
                    <GridTile>
                        <NormalField
                            label="Company"
                            input={this.props.smokeTest.company} />
                    </GridTile>
                    <GridTile>
                        <NormalField
                            label="Name of Witness"
                            input={this.props.smokeTest.nameOfWitness} />
                    </GridTile>
                    <GridTile>
                        <NormalField
                            label="Date"
                            input={this.props.smokeTest.date} />
                    </GridTile>
                    <GridTile>
                        <NormalField
                            label="Time"
                            input={this.props.smokeTest.time} />
                    </GridTile>
                </GridList>
            </div>
        );
    }
}

export default SmokeTest;


// WEBPACK FOOTER //
// src/components/innerComponents/SmokeTest.js